module.exports = __webpack_public_path__ + "static/zmar-1259c7d8a537159ca1a1cf4cbe0c11d3.png";